import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';
import { useAppContext } from 'core/contexts';
import moment from 'moment';

type Indemnite = {
    montantTotal: string;
    dateVirement: string;
    details: any;
};

type Props = {
    indemnite: Indemnite; // Specify the type of indemnite
};

const ListIndemnite: React.FC<Props> = ({ indemnite }) => {
    const classes = useStyles();
    console.log(indemnite);
    return (
        <>
            <Accordion className={classNames(classes.accordion, 'mt-4')}>
                <AccordionSummary
                    expandIcon={<ArrowDropDown style={{ color: '#fff', width: '35px', height: '45px' }} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                >
                    <Box display={'flex'} flexDirection={'row'} justifyContent="center" alignItems="center" className={classes.header}>
                        <Typography component={'div'} className={classNames(classes.dtEmis, classes.centeredText)}>
                            Payé le {moment(indemnite.dateVirement, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                        </Typography>
                        <Typography component={'div'} className={classNames(parseFloat(indemnite.montantTotal) < 0 ? classes.amountNegatif : classes.amount, classes.centeredText)}>
                            {formattedNumber(indemnite.montantTotal)} €
                        </Typography>
                        {indemnite.details.isPaidToAffilie && (
                            <Typography component={'div'} className={classNames(classes.destinataire, classes.centeredText)}>
                                Versé à l'assuré
                            </Typography>
                        )}
                    </Box>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                    <PrestationsTable indemnite={indemnite} />
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default ListIndemnite;

const useStyles = makeStyles(() => ({
    accordion: {
        border: 'none',
        boxShadow: 'none',
    },
    summary: {
        backgroundColor: '#3399DB',
        height: '54px',
        padding: 0,
        paddingRight: '15px',
        '&.Mui-expanded': {
            minHeight: '54px',
        },
    },
    summaryContent: {
        margin: '0',
    },
    details: {
        padding: '0',
    },
    header: {
        height: '54px',
    },
    dtEmis: {
        color: '#fff',
        fontSize: '0.8rem',
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        height: '100%',
        width: '170px',
    },
    amount: {
        color: '#fff',
        fontSize: '1.2rem',
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        background: '#2574A9',
        borderLeft: '1px solid #fff',
        borderRight: '1px solid #fff',
        height: '100%',
        minWidth: '170px',
    },
    amountNegatif: {
        color: '#fff',
        fontSize: '1.2rem',
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        background: '#EB4C37',
        borderLeft: '1px solid #fff',
        borderRight: '1px solid #fff',
        height: '100%',
        minWidth: '170px',
    },
    destinataire: {
        color: '#fff',
        fontSize: '1rem',
        fontFamily: 'Open Sans',
        fontStyle: 'italic',
        height: '100%',
        minWidth: '170px',
        padding: '10px',
    },
    centeredText: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    txtGreen: {
        color: '#2574A9',
        fontSize: '0.83rem ',
        fontFamily: 'Open Sans ',
        fontStyle: 'normal ',
        fontWeight: 700,
    },
    txtBlue: {
        color: '#2574a9',
        fontSize: '0.83rem ',
        fontFamily: 'Open Sans ',
        fontStyle: 'normal ',
        fontWeight: 700,
    },
    tableHeader: {
        background: '#F5F5F5',
    },
}));

const StyledTableRow = styled(TableRow)(() => ({
    backgroundColor: '#E1F1FC',
    borderBottom: 'none',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
}));

const StyledTableCell1 = styled(TableCell)(() => ({
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'center',
    borderRight: '1px solid #cdcdcd',
    borderBottom: '1px solid #cdcdcd',
    borderTop: 'none',
    '&:last-child': {
        borderRight: 'none', // Remove the right border for the last cell
    },
}));

const StyledTableCell = styled(TableCell)(() => ({
    color: '#4F7793',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'center',
    paddingTop: '5px',
    height: '54px',
    paddingBottom: '3px',
    borderBottom: 'none',
    borderRight: '1px solid #cdcdcd',
    borderTop: '1px solid #cdcdcd',
    '&:last-child': {
        background: '#3399DB',
        borderRight: 'none', // Remove the right border for the last cell
        color: '#FFF',
        fontWeight: 700,
    },
}));

const StyledTableCellRed = styled(TableCell)(() => ({
    color: '#4F7793',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'center',
    paddingTop: '5px',
    height: '54px',
    paddingBottom: '3px',
    borderBottom: 'none',
    borderRight: '1px solid #cdcdcd',
    borderTop: '1px solid #cdcdcd',
    '&:last-child': {
        background: '#EB4C37',
        borderRight: 'none', // Remove the right border for the last cell
        color: '#FFF',
        fontWeight: 700,
    },
}));

const StyledTableContainer = styled(TableContainer)(() => ({
    boxShadow: 'none',
    border: '1px solid #3ba7ca',
    borderTop: 'none',
}));

const PrestationsTable = ({ indemnite }) => {
    const { user } = useAppContext();
    const orderedList = indemnite.details.sort((b, a) => new Date(b.dtFinPresta).getTime() - new Date(a.dtFinPresta).getTime());
    const classes = useStyles();
    return (
        <StyledTableContainer>
            <Table>
                <TableHead>
                    <StyledTableRow>
                        <TableCell colSpan={user.features.includes('EXPORT_PRESTATION_AG2R') ? 8 : 6} align="center">
                            <Typography className={classes.txtGreen}>MES DÉCOMPTES</Typography>
                        </TableCell>
                    </StyledTableRow>
                    <TableRow className={classes.tableHeader}>
                        <StyledTableCell1>
                            <Typography className={classes.txtGreen}>Période du sinistre</Typography>
                        </StyledTableCell1>
                        <StyledTableCell1>
                            <Typography className={classes.txtGreen}>Nature</Typography>
                        </StyledTableCell1>
                        <StyledTableCell1>
                            <Typography className={classes.txtGreen}>Mode paiement</Typography>
                        </StyledTableCell1>
                        <StyledTableCell1>
                            <Typography className={classes.txtGreen}>Destinataire</Typography>
                        </StyledTableCell1>
                        {user.features.includes('EXPORT_PRESTATION_AG2R') && (
                            <>
                                <StyledTableCell1>
                                    <Typography className={classes.txtGreen}>Salaire de référence</Typography>
                                </StyledTableCell1>
                                <StyledTableCell1>
                                    <Typography className={classes.txtGreen}>IJ SS</Typography>
                                </StyledTableCell1>
                            </>
                        )}
                        <StyledTableCell1>
                            <Typography className={classes.txtGreen}>Nombre jours de prestations</Typography>
                        </StyledTableCell1>
                        <StyledTableCell1 className="remboursement_cell">
                            <Typography className={classes.txtGreen}>Montant</Typography>
                        </StyledTableCell1>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {orderedList &&
                        orderedList.map((d) => {
                            return (
                                <TableRow className="detail">
                                    <StyledTableCell>
                                        {moment(d.dtDebPresta, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {moment(d.dtFinPresta, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                                    </StyledTableCell>
                                    <StyledTableCell>{d.lbActe}</StyledTableCell>
                                    <StyledTableCell>
                                        {d.lbModPaiment}
                                        {/* {d.lbModPaiment === 'VIREMENT' && d.domicileIban ? d.lbModPaiment : d.lbModPaiment === 'VIREMENT' && !d.domicileIban ? '-' : d.lbModPaiment} */}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {d.isPaidToAffilie ? <Box>L'ASSURÉ</Box> : <Box>{d.destinataire} </Box>}
                                        {d.lbModPaiment === 'VIREMENT' && d.domicileIban && (
                                            <Box display="flex" flexDirection="column">
                                                <Box>
                                                    Domicile IBAN : <span className={classes.txtBlue}>{d.domicileIban}</span>
                                                </Box>
                                                <Box>
                                                    IBAN : <span className={classes.txtBlue}>{d.iban}</span>
                                                </Box>
                                            </Box>
                                        )}
                                    </StyledTableCell>
                                    {user.features.includes('EXPORT_PRESTATION_AG2R') && (
                                        <>
                                            <StyledTableCell style={{ whiteSpace: 'nowrap' }}>{d.revenuref ? formattedNumber(d.revenuref) + ' €' : ''}</StyledTableCell>
                                            <StyledTableCell style={{ whiteSpace: 'nowrap' }}>{d.unitss ? formattedNumber(d.unitss) + ' €' : ''}</StyledTableCell>
                                        </>
                                    )}
                                    <StyledTableCell>{d.nbreJourArret}</StyledTableCell>
                                    {parseFloat(d.montantNet) < 0 ? (
                                        <StyledTableCellRed className="remboursement_cell" style={{ whiteSpace: 'nowrap' }}>
                                            {formattedNumber(d.montantNet)} €
                                        </StyledTableCellRed>
                                    ) : (
                                        <StyledTableCell className="remboursement_cell" style={{ whiteSpace: 'nowrap' }}>
                                            {formattedNumber(d.montantNet)} €
                                        </StyledTableCell>
                                    )}
                                </TableRow>
                            );
                        })}
                </TableBody>
            </Table>
        </StyledTableContainer>
    );
};

const formattedNumber = (number) => {
    const numberAsFloat = parseFloat(number);
    if (!isNaN(numberAsFloat)) {
        return numberAsFloat.toLocaleString('fr-FR', {
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    } else {
        return 'Invalid input';
    }
};
